import React, { Component } from 'react';
import queryString from 'querystring';
import PrivacyPolicyJA from './PrivacyPolicyJA';
import PrivacyPolicyKR from './PrivacyPolicyKR';
import TermsJA from './TermsJA';
import TermsKR from './TermsKR';

class TermsPage extends Component {
  constructor(props) {
    super(props);
    const param = queryString.parse(this.props.location.search.replace('?', ''));
    this.state = {
      lang: param.lang,
    };
  }

  componentDidMount() {}

  render() {
    return <div className="share-container">{this.state.lang === 'jp' || this.state.lang === 'ja' ? <TermsJA /> : <TermsKR />}</div>;
  }
}

export default TermsPage;
